import React from 'react'
import styled from 'styled-components'

const Box = styled.div`
  color: #888;
  font-size: 1.125em;
  margin: 16px;

  form {
    display: flex;
    flex-direction: column;

    div {
      display: flex:
      align-items: flex-end;
      margin-top: 16px;
    }
  }

  input[type='text'], select {
    padding: 0 8px;
    height: 32px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5) inset;
    border: none;
    font-size: 0.875em;
    font-family: 'PT Mono';
  }

  input[type='text'] {
    width: 200px;
  }

  select {
    width: 125px;
    margin: 0 8px 8px 0;
  }

  button {
    font-family: 'PT Mono';
    font-size: 0.875em;
    height: 32px;
    background-color: #999;
    color: #000;
    border: none;
    cursor: pointer;
  }

  @media (min-width: 650px) {
    form {
      flex-direction: row;
      align-items: center;

      div {
        margin-top: 0;
      }
    }

    input, select:first-child {
      margin-left: 16px;
    }
  }
`

const TextInput = (props) => (
  <input
    id='searchInput'
    type='text'
    onChange={ props.onChange }
    />
)

const Selects = (props) => {
  const years = (Array.from(Array(81), (x, index) => index + 1)).reverse()
  return (
    <React.Fragment>
      <select id='month' onChange={ props.onChange }>
        <option value='01'>January</option>
        <option value='02'>February</option>
        <option value='03'>March</option>
        <option value='04'>April</option>
        <option value='05'>May</option>
        <option value='06'>June</option>
        <option value='07'>July</option>
        <option value='08'>August</option>
        <option value='09'>September</option>
        <option value='10'>October</option>
        <option value='11'>November</option>
        <option value='12'>December</option>
      </select>
      <select id='year' onChange={ props.onChange }>
        { years.map((index) => (
          <option key={index} value={ index+1938 }>{ index+1938 }</option>
        )) }
      </select>
    </React.Fragment>
  )
}

//This component lets you switch out different input types depending on what you need.
const Input = (props) => {
  const type = props.type
  if (type === 'textInput') {
    return <TextInput onChange={ props.onChange } />
  } else if (type === 'selects') {
    return <Selects onChange={ props.onChange }  />
  } else {
    return null
  }
}

const Form = (props) => (
  <Box>
    <form>
      <label htmlFor='searchInput'>{ props.instructions }</label>
      <div>
        <Input type={ props.type } onChange={ props.onChange }/>
        <button
          type='submit'
          onClick={ props.onClick }
          >Search</button>
      </div>
    </form>
  </Box>
  )

export default Form
